import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function RegistrationPending() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: '40px',
          textAlign: 'center',
          maxWidth: '500px',
        }}
      >
        <Typography variant="h4" gutterBottom>
          Registration Pending
        </Typography>
        <Typography variant="body1">
          Thank you for registering. Your account is currently awaiting activation.
          Please check your email for a confirmation link or wait for an administrator to approve your account.
        </Typography>
      </Paper>
    </Box>
  );
}

export default RegistrationPending;
